module.exports = __webpack_public_path__ + "img/c_photo_1.ebcf2770.png";